import { RoutingInterface } from '~/core/services/navigation/interfaces/routing.interface';

export const organizerActivitySharingRoutingConfig: RoutingInterface[] = [
  {
    routeName: 'organizer.activity-sharing.steps-3',
  },
  {
    routeName: 'organizer.activity-sharing.share',
  },
  {
    routeName: 'organizer.activity-sharing.success',
  },
];
